module.exports = __webpack_public_path__ + "img/new_logo_resized.c17e8485.jpg";